import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appGGImage]',
  standalone: true
})
export class GgImageDirective {
  @Input() defaultImage: string;

  @HostListener('error') onErrorImage(): void {
    if (this.defaultImage) {
      this.elRef.nativeElement.src = this.defaultImage;
    }
  }

  constructor(private elRef: ElementRef<HTMLImageElement>) {
    if (!elRef.nativeElement.src) {
      this.elRef.nativeElement.src = this.defaultImage;
    }
  }

}
